import React from 'react';
import { DownloadIcon, UserIcon, ListIcon, TerminalIcon } from 'lucide-react';
export function HowItWorksSection() {
  const steps = [{
    id: 1,
    icon: <DownloadIcon className="h-10 w-10 text-[#5e60ce]" data-id="element-341" />,
    title: 'Install & Authenticate',
    description: 'Install Newsfiliate on Kit through the Kit App Marketplace.'
  }, {
    id: 2,
    icon: <UserIcon className="h-10 w-10 text-[#5e60ce]" data-id="element-342" />,
    title: 'Add Affiliate ID',
    description: 'Head over to the Newsfiliate App page and add your Amazon Affiliate ID to you account.'
  }, {
    id: 3,
    icon: <ListIcon className="h-10 w-10 text-[#5e60ce]" data-id="element-343" />,
    title: 'Build Your Deal List',
    description: 'Create a list, search our database of deals, and add products to your list.'
  }, {
    id: 4,
    icon: <TerminalIcon className="h-10 w-10 text-[#5e60ce]" data-id="element-344" />,
    title: 'Add List to Email',
    description: 'Select the list you created to insert it directly into your newsletter.'
  }];
  return <section id="how-it-works" className="py-20 bg-gray-50" data-id="element-345">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-346">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-347">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-348">
            How It Works
          </h2>
          <p className="text-xl text-gray-600" data-id="element-349">
            Get up and running in minutes with our simple four-step process.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6" data-id="element-350">
          {steps.map(step => <div key={step.id} className="bg-white rounded-xl p-8 shadow-md hover:shadow-lg transition-shadow relative" data-id="element-351">
              <div className="absolute -top-4 -left-4 w-10 h-10 rounded-full bg-[#5e60ce] text-white flex items-center justify-center font-bold text-lg" data-id="element-352">
                {step.id}
              </div>
              <div className="flex flex-col items-center text-center pt-4" data-id="element-353">
                <div className="mb-5 p-3 rounded-full" style={{
              backgroundColor: '#f2f1f8'
            }} data-id="element-354">
                  {step.icon}
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-355">
                  {step.title}
                </h3>
                <p className="text-gray-600" data-id="element-356">{step.description}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}